import { useMsal } from '@azure/msal-react'
import { Link } from 'react-router-dom'
import { loginRequest } from '../config/msalConfig'
import AlphaBoldMark from '../components/ui/AlphaBoldMark'

export default function LoginPage() {
  const { instance } = useMsal()

  const handleLogin = () => {
    instance.loginRedirect(loginRequest)
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      {/* Background grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `linear-gradient(#334155 1px, transparent 1px), linear-gradient(90deg, #334155 1px, transparent 1px)`,
          backgroundSize: '48px 48px',
        }}
      />

      <div className="relative z-10 w-full max-w-md">
        {/* Logo / Branding */}
        <div className="text-center mb-8">
          <div className="inline-flex mb-4">
            <AlphaBoldMark size={72} className="drop-shadow-[0_10px_28px_rgba(227,173,33,0.35)]" />
          </div>
          <h1 className="text-2xl tracking-tight text-text-primary">
            <span className="font-normal">alpha</span><span className="font-extrabold text-primary">bold</span><span className="font-bold"> SecOps</span>
          </h1>
          <p className="text-text-muted mt-1 text-sm">MSP Security Operations Platform</p>
        </div>

        {/* Login Card */}
        <div className="card p-8 shadow-2xl">
          <h2 className="text-lg font-semibold text-text-primary mb-1">Sign in to your account</h2>
          <p className="text-text-muted text-sm mb-6">
            Use your Microsoft 365 credentials to access the platform.
          </p>

          <button onClick={handleLogin} className="btn-primary w-full justify-center py-3 text-base">
            {/* Microsoft icon */}
            <svg className="w-5 h-5" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            Continue with Microsoft
          </button>

          <div className="mt-6 pt-6 border-t border-border space-y-3 text-center">
            <p className="text-xs text-text-muted">
              New customer with an invite?{' '}
              <Link to="/signup" className="text-primary hover:underline">Set up your organization</Link>
            </p>
            <p className="text-xs text-text-muted">Secured by Microsoft Entra ID</p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-text-muted mt-6">
          &copy; {new Date().getFullYear()} AlphaBOLD. All rights reserved.
        </p>
      </div>
    </div>
  )
}
